import { api } from "../../api";
import { v2ApiPath } from "../v2ApiPath";

/**
 * Jobs v2 reads. The route is rejected unless `jobs.v2.enabled` is true.
 */
const jobsV2Api = api.injectEndpoints({
  endpoints: (builder) => ({
    getJobV2: builder.query({
      query: ({ jobId }) => v2ApiPath(`jobs/${jobId}`),
      transformResponse: (response) => response?.data ?? response,
      providesTags: (result, _error, { jobId }) => [
        { type: "Jobs", id: result?._id || jobId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetJobV2Query } = jobsV2Api;

export default jobsV2Api;
